import dynamic from 'next/dynamic'

import { mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { AccordionContainer } from '@thg-commerce/enterprise-widget-accordion-container'
import { QuantitySelector } from '@thg-commerce/gravity-elements'
import { ProductBlock } from '@thg-commerce/gravity-patterns'
import { Grid } from '@thg-commerce/gravity-system'

const Close = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Close'),
)

const SuccessIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/IconSuccess'),
)

const IconInfo = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/IconInfo'),
)

export const StyledAccordionContainer = styled(AccordionContainer)`
  width: 100%;

  input + label {
    border-top: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  }
`

export const StyledProductBlock = styled(ProductBlock)<{
  selectedProduct: boolean
  notSelectable: boolean
  maxProductsSelected: boolean
  isProductSelected?: boolean
}>`
  height: 100%;
  cursor: pointer;
  box-shadow: ${(props) =>
    props.selectedProduct ? 'none;' : '0 0 0 1px rgba(0, 0, 0, 0.3)'};
  ${(props) => props.isProductSelected && `padding-bottom: ${spacing(8)}`};

  border: ${(props) =>
    `3px solid ${
      props.selectedProduct
        ? props.theme.colors.palette.brand.base
        : 'transparent;'
    }`};
  ${(props) => props.notSelectable && 'opacity: .7; pointer-events: none;'};
  border-radius: 2px;

  ${(props) =>
    props.maxProductsSelected && !props.selectedProduct && 'opacity: .7;'};
  a + div {
    padding: 0 ${spacing(1)};
  }
`

export const StyledGrid = styled(Grid)`
  padding-bottom: ${spacing(8)};
  grid-gap: ${spacing(1.5)};
`

export const CloseIcon = styled(Close)`
  background-color: ${(props) => props.theme.colors.palette.brand.base};
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: 8px solid ${(props) => props.theme.colors.palette.brand.base};
  path {
    fill: ${(props) => props.theme.colors.palette.greys.white};
  }
`

export const QuantityWrapper = styled.div`
  position: absolute;
  bottom: ${spacing(3)};
  display: flex;
  justify-content: center;
  width: 100%;
`

export const StyledQuantitySelector = styled(QuantitySelector)`
  width: 144px;
  ${({ theme }) => mq(theme.breakpointUtils.map, 'sm')} {
    width: auto;
  }
`

export const IconContainer = styled.div`
  background: ${(props) => props.theme.colors.palette.greys.dark};
  position: absolute;
  top: 1.5px;
  right: 1.5px;
  display: flex;
`

export const IconAndTextContainer = styled.div`
  padding: ${spacing(1)};
  display: flex;
  align-items: center;
`

export const SelectedProductsText = styled.span<{
  maxProductsReached?: boolean
}>`
  padding-left: ${spacing(1)};
  ${Text('bodyText', 'default')};
  ${(props) =>
    props.maxProductsReached && `color: ${props.theme.colors.success.base}`};
`

export const CategoryItemSubtitle = styled.p`
  ${Text('bodyText', 'default')};
  padding: ${spacing(1)};
`

export const StyledSuccessIcon = styled(SuccessIcon)`
  path {
    fill: ${(props) => props.theme.colors.success.base};
  }
`

export const OutOfStockSubtitle = styled.p`
  ${Text('medium1', 'default')};
`

export const OutOfStockTitle = styled.p`
  ${Text('large1', 'alternate')};
`

export const InfoIconButton = styled.button`
  position: absolute;
  left: ${spacing(1)};
  top: ${spacing(1)};
`

export const StyledIconInfo = styled(IconInfo)`
  path {
    fill: ${(props) => props.theme.colors.palette.brand.base};
  }
`

export const Title = styled.p`
  ${Text('large2', 'alternate')};
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};
`

export const SubTitle = styled.p`
  ${Text('large2', 'alternate')};
  padding: ${spacing(3)} 0 ${spacing(3)};
`
export const OutOfStock = styled.div`
  padding: 0 ${spacing(1)};
  position: absolute;
  top: 95px;
  left: 0;
  right: 0;
  text-align: center;
`
